var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      attrs: { novalidate: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.sendToPreview.apply(null, arguments)
        },
      },
    },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "form__group" },
        [
          _c("legend", [_vm._v("Supporting Documents")]),
          _vm._v(" "),
          _c("FileUpload", {
            attrs: { id: "documents", name: "documents", multiple: "true" },
            model: {
              value: _vm.formData.documents,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "documents", $$v)
              },
              expression: "formData.documents",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group form__group--submit" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "documents uploading"],
                    expression: '["submit", "documents uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.back.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Back")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "wait",
                    rawName: "v-wait:disabled",
                    value: ["submit", "documents uploading"],
                    expression: '["submit", "documents uploading"]',
                    arg: "disabled",
                  },
                ],
                staticClass: "btn btn--primary",
              },
              [_vm._v("Save & Preview")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }